import React from "react";
import { Card, Typography } from "antd";
import { ListFiles, UploadFileButton } from "./components";
import { auth } from "src/lib/firebase";
import { useLoaderData } from "react-router-dom";
import { MyDocumentPageLoaderType } from "./loaders";
import * as APITypes from "~/API";
import { useAppTranslation } from "~/hooks/useAppTranslation";

const { Text } = Typography;

export const MyDocumentPage: React.FC = () => {
  const currentUser = auth.currentUser;
  const _loaderData = useLoaderData() as MyDocumentPageLoaderType;
  const { t } = useAppTranslation();
  return (
    <>
      <Text>
        <Card title={t("My_Documents")}>
          <UploadFileButton
            currentUser={currentUser?.uid ?? ""}
            entityId={currentUser?.uid ?? ""}
            entityType={APITypes.EntityType.User}
          />
          <br />
          <ListFiles />
        </Card>
      </Text>
    </>
  );
};
